import { lazy } from "react";
import RouteGuard from "../routerPermission";

const Roles = lazy(() =>
  import("@/pages/vendor/roles").then((m) => ({ default: m.RolesListPage }))
);
const RoleDetails = lazy(() =>
  import("@/pages/vendor/roles").then((m) => ({ default: m.RoleDetailsPage }))
);

const RolesRoutes = {
  path: "roles",
  children: [
    {
      path: "",
      element: (
        <RouteGuard resource="role" action="read">
          <Roles />
        </RouteGuard>
      ),
    },
    {
      path: ":roleId",
      element: (
        <RouteGuard resource="role" action="read">
          <RoleDetails />
        </RouteGuard>
      ),
    },
  ],
};

export default RolesRoutes;
